import { URL_MAPPING } from './host-mapping';
  
const currentHost  = window.location.host;

// var hostObj = {
//     "vendx" : "vend-x.com",
//     "utcl" : "ultratechcement.vend-x.com",
//     "ejbuy" : "ej-buy.com",
// }
// const urlParams = new URLSearchParams(window.location.search);
// const myParam = urlParams.get('CURRENTIFRAMEHOST');
// // const queryParams = Object.fromEntries(new URLSearchParams(location.search).entries());

var host= typeof URL_MAPPING[currentHost] != 'undefined' ?  currentHost : "default";
// if(myParam && hostObj.hasOwnProperty(myParam)){
//     console.log(hostObj[myParam],"hostObj[myParam]hostObj[myParam]hostObj[myParam]");
    
//     host = hostObj[myParam];
// }

// console.log(currentHost,"currentHOst",host);
// console.log(myParam,"myParammyParam",hostObj,hostObj.hasOwnProperty(myParam));


export const HOSTMAP = URL_MAPPING[host]['parent_host'];
export const API_URL = URL_MAPPING[host]['api_host'];
export const CURRENTHOST = URL_MAPPING[host]['current_host'];
export const VENDX2 = URL_MAPPING[host]['vendx2_host'];

export const URL_DETAILS = URL_MAPPING[host];
